import classNames from "classnames";
import React from "react";
import { UncontrolledPopover } from "tsi-common-react/src/common/Popover";

interface IProps {
    id: string;
    labelText: string;
    onAfterClose?: () => void;
    onAfterOpen?: () => void;
    children?: React.ReactNode;
}

export const LocatorFilterPopover = React.forwardRef<
    { onRequestClose: () => void },
    IProps
>((props, ref): React.ReactNode => {
    const popperElem = React.useRef<UncontrolledPopover>(null);

    React.useImperativeHandle(ref, () => ({
        onRequestClose: () => {
            if (popperElem.current) {
                popperElem.current.requestClose();
            }
        },
    }));

    const labelClasses = classNames({
        filters__filter: true,
        [`filters__filter--${props.id}`]: true,
    });
    const modalClasses = classNames({
        filters__dropdown: true,
        [`filters__dropdown--${props.id}`]: true,
    });

    return (
        <UncontrolledPopover
            ref={popperElem}
            triggerContent={props.labelText}
            triggerBtnProps={{
                className: labelClasses,
            }}
            popperOptions={{
                placement: "bottom",
            }}
            modalProps={{
                contentLabel: props.labelText,
                style: {
                    overlay: {
                        backgroundColor: "transparent",
                    },
                },
            }}
            onAfterOpen={props.onAfterOpen}
            onAfterClose={props.onAfterClose}
        >
            <div className={modalClasses}>{props.children}</div>
        </UncontrolledPopover>
    );
});
